module.exports = __webpack_public_path__ + "static/img/training_widget_2.59de314.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/training_widget_2.png
// module id = 4jWR
// module chunks = 11